import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";

interface MediaSkeletonProps {
  className?: string; // Allow custom classes for sizing or spacing
  showSpinner?: boolean;
}

export const MediaSkeleton: React.FC<MediaSkeletonProps> = ({
  className = "",
  showSpinner = true,
}) => {
  return (
    <div
      className={`w-full h-full bg-gray-200/80 animate-pulse flex flex-col items-center justify-center text-gray-400 rounded-lg overflow-hidden backdrop-blur-sm ${className}`}
    >
      {showSpinner && <LoadingSpinner />}
    </div>
  );
};
